import api from './index'
import request from '@/utils/request'

/**
 * @description 商户信息查询
 */
export function merchantSale (data) {
  return request({
    url: `${api.merchantSale}`,
    method: 'post',
    data
  })
}

/**
 * @description 商户信息查询
 */
export function merchantInfo (data) {
  return request({
    url: `${api.merchantInfo}`,
    method: 'post',
    data
  })
}

/**
 * @description 一代代理商修改商户交易权限
 */
export function modifyMerchantTradeStatus (data) {
  return request({
    url: `${api.modifyMerchantTradeStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户信息证件过期商户统计
 */
export function countCardExpireMerchant (data) {
  return request({
    url: `${api.countCardExpireMerchant}`,
    method: 'post',
    data
  })
}
/**
 * @description 校验总商户编号
 */
export function checkMerchantId (data) {
  return request({
    url: `${api.checkMerchantId}`,
    method: 'post',
    data
  })
}
/**
 * @description 检查商户名是否可用
 */
export function checkUsername (data) {
  return request({
    url: `${api.checkUsername}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件获取商户信息
 */
export function getMerchantInfo (data) {
  return request({
    url: `${api.getMerchantInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商可用微信渠道号查询
 */
export function getAvailableChannel (data) {
  return request({
    url: `${api.getAvailableChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 所有下级业务员列表查询
 */
export function queryAllSale (data) {
  return request({
    url: `${api.queryAllSale}`,
    method: 'post',
    data
  })
}
/**
 * @description 下级代理商信息查看
 */
export function subAgentInfo (data) {
  return request({
    url: `${api.subAgentInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户信息导出
 */
export function exportMerchantList (data) {
  return request({
    url: `${api.exportMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 申请记录商户信息导出
 */
export function exportReportMerchantList (data) {
  return request({
    url: `${api.exportReportMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 证件过期商户导出
 */
export function exportExpiredMerchant (data) {
  return request({
    url: `${api.exportExpiredMerchant}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户智能进件
 */
export function intellectRegister (data) {
  return request({
    url: `${api.intellectRegister}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件更新
 */
export function updateIntellectMerchant (data) {
  return request({
    url: `${api.updateIntellectMerchant}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件费率提交
 */
export function setCommission (data) {
  return request({
    url: `${api.setCommission}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件查询进件结果
 */
export function checkMerchantStatus (data) {
  return request({
    url: `${api.checkMerchantStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询蓝海行动商户列表
 */
export function getBlueSeaMerchantList (data) {
  return request({
    url: `${api.getBlueSeaMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取蓝海行动省市区街道
 */
export function blueSeaArea (data) {
  return request({
    url: `${api.blueSeaArea}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户查询蓝海行动详细资料
 */
export function getBlueSeaInfo (data) {
  return request({
    url: `${api.getBlueSeaInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 提交参加蓝海行动资料
 */
export function updateBlueSeaInfo (data) {
  return request({
    url: `${api.updateBlueSeaInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 提交参加蓝海行动备注
 */
export function setBlueSeaRemark (data) {
  return request({
    url: `${api.setBlueSeaRemark}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询绿洲计划商户列表
 */
export function getOasisMerchantList (data) {
  return request({
    url: `${api.getOasisMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取綠洲行动省市区街道
 */
export function oasisArea (data) {
  return request({
    url: `${api.oasisArea}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户查询绿洲行动详细资料
 */
export function getOasisInfo (data) {
  return request({
    url: `${api.getOasisInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 提交参加绿洲行动资料
 */
export function updateOasisInfo (data) {
  return request({
    url: `${api.updateOasisInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 提交参加绿洲行动备注
 */
export function setOasisRemark (data) {
  return request({
    url: `${api.setOasisRemark}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询商户微信公众号信息
 */
export function getWxConfigInfo (data) {
  return request({
    url: `${api.getWxConfigInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 配置商户微信公众号参数
 */
export function setWxConfigInfo (data) {
  return request({
    url: `${api.setWxConfigInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 配置微信公众号获取子商户列表
 */
export function reportWechatMerchantList (data) {
  return request({
    url: `${api.reportWechatMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 银联活动商户信息列表
 */
export function unionActivityMerchantList (data) {
  return request({
    url: `${api.unionActivityMerchantList}`,
    method: 'post',
    data
  })
}
/**
 * @description 银联活动商户报备
 */
export function unionActivityMerchantInit (data) {
  return request({
    url: `${api.unionActivityMerchantInit}`,
    method: 'post',
    data
  })
}
/**
 * @description 银联活动商户列表导出
 */
export function exportUnionMerchant (data) {
  return request({
    url: `${api.exportUnionMerchant}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商入网申请
 */
export function agentRegister (data) {
  return request({
    url: `${api.agentRegister}`,
    method: 'post',
    data
  })
}
/**
 * @description 直营分店进件
 */
export function directBranchRegister (data) {
  return request({
    url: `${api.directBranchRegister}`,
    method: 'post',
    data
  })
}
/**
 * @description 直营分店进件
 */
export function updateDetailInfo (data) {
  return request({
    url: `${api.updateDetailInfo}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商查询微信渠道信息
 */
export function getAgentChannel (data) {
  return request({
    url: `${api.getAgentChannel}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件查询修改结算卡审核状态
 */
export function checkSettleStatus (data) {
  return request({
    url: `${api.checkSettleStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 智能进件快速修改结算卡
 */
export function quicklyModifyAccount (data) {
  return request({
    url: `${api.quicklyModifyAccount}`,
    method: 'post',
    data
  })
}

/**
 * @description 流失商户列表
 */
export function lostMerchantList (data) {
  return request({
    url: `${api.lostMerchantList}`,
    method: 'post',
    data
  })
}

/**
 * @description 查看各个流失商户统计数据
 */
export function lostSumStatistic (data) {
  return request({
    url: `${api.lostSumStatistic}`,
    method: 'post',
    data
  })
}

/**
 * @description 流失商户导出数据
 */
export function exportLostMerchant (data) {
  return request({
    url: `${api.exportLostMerchant}`,
    method: 'post',
    data
  })
}

/**
 * @description 流失商户统计数据
 */
export function lostStatistic (data) {
  return request({
    url: `${api.lostStatistic}`,
    method: 'post',
    data
  })
}

/**
 * @description 开启商户刷卡退款/关闭T0交易结算
 */
export function updateRefundState (data) {
  return request({
    url: `${api.updateRefundState}`,
    method: 'post',
    data
  })
}

/**
 * @description 代理商入网申请
 */
export function agentRegisterNew (data) {
  return request({
    url: `${api.agentRegisterNew}`,
    method: 'post',
    data
  })
}

/**
 * @description 代理商入网申请驳回编辑
 */
export function updateRegister (data) {
  return request({
    url: `${api.updateRegister}`,
    method: 'post',
    data
  })
}

/**
 * @description 代理商入网申请驳回编辑
 */
export function checkAuthBusiness (data) {
  return request({
    url: `${api.checkAuthBusiness}`,
    method: 'post',
    data
  })
}

/**
 * @description 代理商入网申请驳回编辑
 */
export function checkAuthIdCard (data) {
  return request({
    url: `${api.checkAuthIdCard}`,
    method: 'post',
    data
  })
}

/**
 * @description 更新联系人信息
 */
export function updateContactInfo (data) {
  return request({
    url: `${api.updateContactInfo}`,
    method: 'post',
    data
  })
}

/**
 * @description 查询商户交易权限状态
 */
export function checkMerchantTransStatus (data) {
  return request({
    url: `${api.checkMerchantTransStatus}`,
    method: 'post',
    data
  })
}
/**
 * @description 开通扫码点单
 */
export function openScanOrder (data) {
  return request({
    url: `${api.openScanOrder}`,
    method: 'post',
    data
  })
}
/**
 * @description 开通T0结算
 */
export function openT0Settle (data) {
  return request({
    url: `${api.openT0Settle}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户授权列表查询
 */
export function merchantAuthList (data) {
  return request({
    url: `${api.authList}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户授权日志列表查询
 */
export function merchantAuthLogList (params) {
  return request({
    url: `${api.authLogList}`,
    method: 'get',
    params
  })
}
/**
 * @description 商户激活码列表查询
 */
export function merchantActivationCodeList (data) {
  return request({
    url: `${api.activationCodeList}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户授权服务列表查询
 */
export function merchantAuthServiceList (data) {
  return request({
    url: `${api.authServiceList}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户授权预下单
 */
export function merchantAuthPreOrder (data) {
  return request({
    url: `${api.authPreOrder}`,
    method: 'post',
    data
  })
}
/**
 * @description 商户授权激活
 */
export function merchantAuthActivation (data) {
  return request({
    url: `${api.authActivation}`,
    method: 'post',
    data
  })
}

/**
 * @description 【连锁-代理商后台-门店升级连锁版】获取需要升级的门店数量和激活码信息
 */
export function upgradeShopList (data) {
  return request({
    url: `${api.upgradeShopList}`,
    method: 'post',
    data
  })
}
/**
 * @description 【连锁-代理商后台-门店升级连锁版】创建升级订单
 */
export function upgradeOrderInit (data) {
  return request({
    url: `${api.upgradeOrderInit}`,
    method: 'post',
    data
  })
}
/**
 * @description 【连锁-代理商后台-门店升级连锁版】升级订单支付状态
 */
export function upgradeOrderPayStatus (data) {
  return request({
    url: `${api.upgradeOrderPayStatus}`,
    method: 'post',
    data
  })
}

/**
 * @description 升级连锁
 */
export function upgradeToChainShop (params) {
  return request({
    url: `${api.upgradeToChainShop}`,
    method: 'get',
    params
  })
}
